import React from 'react';
import SearchBar from '../../../components/searchBar';
import Table from '../../../components/table';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { history } from '../../../configuration/store';
import { resolveRoleName, getViceVersaFullName } from '../../../utilities/string';
import { sortByName, sortByPhone, sortByRoleThenName } from '../../../utilities/sortUser';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

class UsersTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchString: undefined
        };

        this.getColumnDefinition = this.getColumnDefinition.bind(this);
        this.filterResults = this.filterResults.bind(this);
        this.getContractorRole = this.getContractorRole.bind(this);
        this.goToDetails = this.goToDetails.bind(this);
    }

    getContractorRole(user) {
        return user.roles.find(r => r.role === 'contractor');
    }

    goToDetails(user) {
        const { client } = this.props;
        const contractorRole = this.getContractorRole(user);
        if (contractorRole) {
            history.push(`/worker/${client.id}/${contractorRole.resource_id}/${user.id}`);
        } else {
            const clientUserRole = user.roles.find(r => r.resource === 'client' && r.resource_id === client.id);
            if (clientUserRole) {
                history.push(`/user/${clientUserRole.resource}/${client.id}/${user.id}`);
            }
        }
    }

    getImpersonateAction() {
        const { setImpersonateRole, setRoleSelectorVisibility } = this.props;
        return {
            valueMap: d => (
                <div className="full-height-cell ellipsis">
                    <i className="material-icons" onClick={() => setImpersonateRole(d, role => setRoleSelectorVisibility(true, { role }))}>
                        visibility
                    </i>
                </div>
            ),
            size: 'col-xs-2 text-right pull-right'
        };
    }

    getColumnDefinition() {
        const { role, companyColumnTitle } = this.props;
        let showCompanyColumn = role.type === 'admin';

        let columns = [
            {
                label: <FormattedMessage {...messages.name} />,
                valueMap: d => (
                    <div className="row name-column clickable" onClick={() => this.goToDetails(d)}>
                        <div className="col-xs-12 name-cell ellipsis">{getViceVersaFullName(d)}</div>
                        <div className="col-xs-12 email-cell ellipsis">{d.email}</div>
                    </div>
                ),
                size: showCompanyColumn ? 'col-md-3 col-sm-6 col-xs-10' : 'col-md-6 col-sm-9 col-xs-10',
                sort: sortByName
            },
            {
                label: <FormattedMessage {...messages.phone} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis clickable" onClick={() => this.goToDetails(d)}>
                        {d.phone ? formatPhoneNumberIntl(d.phone) : <FormattedMessage {...messages.notProvided} />}
                    </div>
                ),
                size: 'col-md-3 hidden-sm hidden-xs',
                sort: sortByPhone
            },
            {
                label: <FormattedMessage {...messages.role} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis clickable" onClick={() => this.goToDetails(d)}>
                        {d.roles && d.roles.length > 0 ? resolveRoleName(d.roles[0].role) : <FormattedMessage {...messages.notProvided} />}
                    </div>
                ),
                size: 'col-xs-2 hidden-xs',
                sort: sortByRoleThenName,
                descSort: (a, b) => sortByRoleThenName(b, a, true)
            }
        ];

        if (showCompanyColumn) {
            columns.push({
                label: <FormattedMessage {...companyColumnTitle} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis clickable" onClick={() => this.goToDetails(d)}>
                        {d.roles && d.roles.length > 0 ? d.roles[0].resource_name : <FormattedMessage {...messages.notProvided} />}
                    </div>
                ),
                size: 'col-xs-2 hidden-xs',
                sort: (a, b) =>
                    (a.roles && a.roles.length > 0 ? a.roles[0].resource_name : '').localeCompare(b.roles && b.roles.length > 0 ? b.roles[0].resource_name : '')
            });
        }
        columns.push(this.getImpersonateAction());
        return columns;
    }

    filterResults() {
        const { users } = this.props;
        const { searchString } = this.state;

        if (!searchString || searchString.trim() === '') {
            return users;
        }

        let filter = searchString.toLowerCase();
        return users.filter(u => u.email.toLowerCase().indexOf(filter) >= 0 || `${u.first_name} ${u.last_name}`.toLowerCase().indexOf(filter) >= 0);
    }

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <SearchBar onSubmit={d => this.setState({ ...this.state, searchString: d.value })} />
                    </div>
                </div>
                <div className="col-xs-12">
                    <Table data={this.filterResults()} columns={this.getColumnDefinition()} defaultSortColumn={0} />
                </div>
            </React.Fragment>
        );
    }
}

UsersTab.defaultProps = {
    companyColumnTitle: messages.company
};

export default UsersTab;



// WEBPACK FOOTER //
// ./src/pages/client/tabs/users.jsx